import { Center, Text, Stack, Title } from '@mantine/core';
import { ShieldX } from 'lucide-react';
import type { Permission } from '@bmai/shared';
import { useAuth } from './AuthContext.tsx';

interface ProtectedRouteProps {
    children: React.ReactNode;
    permission?: Permission;
    role?: string;
}

export function ProtectedRoute({ children, permission, role }: ProtectedRouteProps): React.ReactElement | null {
    const { isAuthenticated, isLoading, hasPermission, hasRole } = useAuth();

    if (isLoading) return null;
    if (!isAuthenticated) return null;

    if (role && !hasRole(role)) return <AccessDenied />;
    if (permission && !hasPermission(permission)) return <AccessDenied />;

    return <>{children}</>;
}

function AccessDenied(): React.ReactElement {
    return (
        <Center h="60vh">
            <Stack align="center" gap="md">
                <ShieldX size={48} />
                <Title order={3}>Access Denied</Title>
                <Text c="dimmed">You don't have permission to view this page.</Text>
            </Stack>
        </Center>
    );
}
